import { lazy } from 'react';

function lazyWithRetry(importer) {
  return lazy(() =>
    importer().catch(() => {
      if (typeof window !== 'undefined') {
        const key = 'hrd_chunk_retry';
        const last = Number(sessionStorage.getItem(key) || 0);
        if (Date.now() - last > 10000) {
          sessionStorage.setItem(key, String(Date.now()));
          window.location.reload();
        }
      }
      return importer();
    })
  );
}

export const SignUpPage = lazyWithRetry(() => import('./SignUpPage'));
export const HomePage = lazyWithRetry(() => import('./HomePage'));
export const EmployeesPage = lazy(() => import('./EmployeesPage'));
export const RecruitmentPage = lazy(() => import('./RecruitmentPage'));
export const AttendancePage = lazy(() => import('./AttendancePage'));
export const WorkSchedulesPage = lazy(() => import('./WorkSchedulesPage'));
export const EmployeeRequestsPage = lazy(() => import('./EmployeeRequestsPage'));
export const AdminRequestsPage = lazy(() => import('./AdminRequestsPage'));
export const PayrollPage = lazy(() => import('./PayrollPage'));
export const KpiPage = lazy(() => import('./KpiPage'));
export const ViolationsPage = lazy(() => import('./ViolationsPage'));
export const SalaryComponentsPage = lazy(() => import('./SalaryComponentsPage'));
export const SalaryProfilesPage = lazy(() => import('./SalaryProfilesPage'));
export const RemindersPage = lazy(() => import('./RemindersPage'));
export const QrAttendanceScannerPage = lazy(() => import('./QrAttendanceScannerPage'));
export const MonthlyReportPage = lazy(() => import('./MonthlyReportPage'));
export const BusinessTripReportPage = lazy(() => import('./BusinessTripReportPage'));
export const DailyJournalPage = lazy(() => import('./DailyJournalPage'));
export const AdminDailyJournalPage = lazy(() => import('./AdminDailyJournalPage'));
export const InterviewPage = lazy(() => import('./InterviewPage'));
export const TrainingPage = lazy(() => import('./TrainingPage'));
export const TrainingCatalogPage = lazy(() => import('./TrainingCatalogPage'));
export const CourseViewPage = lazy(() => import('./CourseViewPage'));
export const MemoPage = lazy(() => import('./MemoPage'));
export const CalendarPage = lazy(() => import('./CalendarPage'));
export const SOPManagementPage = lazy(() => import('./SOPManagementPage'));
export const SettingsPage = lazy(() => import('./SettingsPage'));
export const WigManagementPage = lazy(() => import('./WigManagementPage'));
export const PermitRequestFormPage = lazy(() => import('./PermitRequestFormPage'));
export const LeaveRequestFormPage = lazy(() => import('./LeaveRequestFormPage'));
export const SickLeaveRequestFormPage = lazy(() => import('./SickLeaveRequestFormPage'));
export const CourseEditorPage = lazy(() => import('./CourseEditorPage'));
export const AssetManagementPage = lazy(() => import('./AssetManagementPage'));
export const OnboardingOffboardingPage = lazy(() => import('./OnboardingOffboardingPage'));
export const AcceptInvitationPage = lazy(() => import('./AcceptInvitationPage'));
export const PublicPsikotesPage = lazyWithRetry(() => import('./public/PublicPsikotesPage'));
export const MyPlanningPage = lazy(() => import('./MyPlanningPage'));
export const BriefingHarianPage = lazy(() => import('./isp/BriefingHarianPage'));
export const LogbookTeknisiPage = lazy(() => import('./isp/LogbookTeknisiPage'));
export const ShiftHandoverPage = lazy(() => import('./isp/ShiftHandoverPage'));
export const IspOperationsDashboardPage = lazy(() => import('./isp/IspOperationsDashboardPage'));
export const CoordinatorDailyPage = lazy(() => import('./isp/CoordinatorDailyPage'));
export const StandbyOnCallPage = lazy(() => import('./isp/StandbyOnCallPage'));
export const KelolaTiketPage = lazy(() => import('./isp/KelolaTiketPage'));
export const PerintahTiketPage = lazy(() => import('./isp/PerintahTiketPage'));
export const JointerStatusPage = lazy(() => import('./isp/JointerStatusPage'));
export const HelpdeskShiftAttendancePage = lazy(() => import('./isp/HelpdeskShiftAttendancePage'));
export const ComplaintsPage = lazy(() => import('./ComplaintsPage'));
export const AdminComplaintsPage = lazy(() => import('./AdminComplaintsPage'));
export const DiscTestPage = lazy(() => import('./disc/DiscTestPage'));
export const DiscResultsPage = lazy(() => import('./disc/DiscResultsPage'));
export const DiscResultDetailPage = lazy(() => import('./disc/DiscResultDetailPage'));
export const DiscPrintPage = lazy(() => import('./disc/DiscPrintPage'));
export const DiscScanPage = lazy(() => import('./disc/DiscScanPage'));
export const PapiTestPage = lazy(() => import('./papi/PapiTestPage'));
export const PapiResultsPage = lazy(() => import('./papi/PapiResultsPage'));
export const PapiResultDetailPage = lazy(() => import('./papi/PapiResultDetailPage'));
export const PapiPrintPage = lazy(() => import('./papi/PapiPrintPage'));
export const PapiScanPage = lazy(() => import('./papi/PapiScanPage'));
export const TrainingApprovalsPage = lazy(() => import('./TrainingApprovalsPage'));
export const CompetencyAssessmentPage = lazy(() => import('./CompetencyAssessmentPage'));
export const KasbonRequestFormPage = lazy(() => import('./KasbonRequestFormPage'));
export const FinanceKasbonPage = lazy(() => import('./FinanceKasbonPage'));
export const MaterialRequestPage = lazy(() => import('./MaterialRequestPage'));
export const ProcurementMaterialRequestPage = lazy(() => import('./ProcurementMaterialRequestPage'));
export const OvertimeRequestFormPage = lazy(() => import('./OvertimeRequestFormPage'));
export const LateRequestFormPage = lazy(() => import('./LateRequestFormPage'));
export const EarlyLeaveRequestFormPage = lazy(() => import('./EarlyLeaveRequestFormPage'));
export const PIPsPage = lazy(() => import('./PIPsPage'));
export const MediationsPage = lazy(() => import('./MediationsPage'));
export const UserManagementPage = lazy(() => import('./UserManagementPage'));
export const EmployeeKpiScoreboardPage = lazy(() => import('./EmployeeKpiScoreboardPage'));
export const HeadKpiTeamPage = lazy(() => import('./HeadKpiTeamPage'));
export const JobCandidatesPage = lazy(() => import('./JobCandidatesPage'));
export const ProfilePage = lazy(() => import('./ProfilePage'));
export const PendingRegistrations = lazy(() => import('../components/PendingRegistrations'));
export const MainLayout = lazyWithRetry(() => import('../components/layout/MainLayout'));
